import './Spinner.scss';
import React from 'react';

const Spinner = () => <div className="loader"></div>;

export default Spinner;
